import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import VueRouter from 'vue-router';
import Router from 'vue-router';
import router from "../router.js";
import VueAxios from "vue-axios";
import VueCookies from 'vue-cookies'




Vue.use(Vuex);
Vue.use(VueAxios, axios);
Vue.use(Router)
Vue.use(VueCookies);

// MHN: change before push
const baseURL = process.env.VUE_APP_BASE_URL_NODE;
//const baseURL = "http://localhost:8000/node-influencers";
const config = "";

const urlSearchResults = baseURL + "/searchInfluencers";

const urlCategoriesList = baseURL + "/search_categories";





export default ({
  name: 'user',
  state: {
    retailers: {
      fullname: '',
      email: '',
      followers: null,
      category: '',
      location: '',
      min: 0,
      max: 0,
      country: '',
      followers_title: '',
      final_cat: '',
      keyword:'',
    },
    result: {},
    categories: [
      "Tourism",
      "Kids",
      "Real Estate",
      "Parties",
      "Music",
      "Babies",
      "Media",
      "Entertainment",
      "Fashion Modeling",
      "Spirituality",
      "Luxury",
      "TV",
      "Cinema",
      "Humanities",
      "Pets",
      "Parenting",
      "Social Media",
      "Tattoos",
      "Leisure",
      "Technology",
      "Marketing",
      "Vegan",
      "LGBT",
      "Basketball",
      "Surfing",
      "Motorcycles",
      "Toys",
      "Motivation",
      "Nutrition",
      "Photography",
      "Digital Marketing",
      "Bodybuilding",
      "Crossfit",
      "Dance",
      "Nature",
      "Home Decor and Improvement",
      "Event Planning",
      "Cars",
      "Clothes and Accessories",
      "Catering",
      "Bars and Restaurants",
      "Wellness and Nature",
      "Food Photography",
      "Mommy",
      "Design",
      "Running",
      "Racing",
      "Internet",
      "Drinks",
      "Gaming",
      "Beauty and Cosmetics",
      "Comedy",
      "Lifestyle",
      "Cooking",
      "Beauty Blogger",
      "Modeling",
      "Fitness",
      "Blogging",
      "Acting",
      "Fashion Blogger",
      "Art",
      "Fashion",
      "Fitness Models",
      "Hotels",
      "Performing Arts",
      "Handmade",
      "Food Blogger",
      "Public Relations",
      "Health",
      "Travel",
      "Writing",
      "Food",
      "Science",
      "Business and Economy",
      "Yoga",
      "Comics",
      "Entrepreneur",
      "Education",
      "Wedding",
      "Radio",
      "Sports",
      "Soccer",
    ],



  },

  actions: {

    getSearchResult({
      commit,
      state
    }) {
      let url = urlSearchResults +'?query='+this.state.user.retailers.keyword+ '&followers_lte=' + this.state.user.retailers.max + '&followers_gte=' + this.state.user.retailers.min + '&categories_and=' + this.state.user.retailers.final_cat + '&location_country=' + this.state.user.retailers.country + '&order_by=followers&page=1'
      let config = {

      };

      axios.get(url, config).then(result => {
        commit('GET_SEARCH_RESULT', result.data);
      }).catch(error => {
        // throw new Error(`API ${error}`);
        console.log(error);
        commit('GET_SEARCH_RESULT_ERROR', error.response.status);
      });
    },



    getCategoriesList({
      commit,
      state
    }) {
      let url = urlCategoriesList;
      let config = {

      };

      axios.get(url, config).then(result => {
        commit('GET_CAT_RESULT', result.data);
      }).catch(error => {
        // throw new Error(`API ${error}`);
        console.log('error GET_CAT_RESULT ', error);
        commit('GET_CAT_RESULT_ERROR', error);
      });
    },





  },
  mutations: {

    GET_SEARCH_RESULT(state, res) {
      this.state.user.result = res;
      console.log('res', res);
    },

    GET_SEARCH_RESULT_ERROR(state, res) {
      console.log('res', res);
    },

    GET_CAT_RESULT(state, res) {
      this.state.user.categories = [];
      this.state.user.categories = res.data.categories.map(
        x => x.category
      )

     // console.log('res categories',  this.state.user.categories);
    },

    GET_CAT_RESULT_ERROR(state, res) {
      console.log('state if error cat', res);
    },





  }
})